export default __webpack_public_path__ + "static/media/MrBrighta3.387ccd37.png";